/**
 * 特陈竞价接口
 */
import axios from './http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const resource = {
    
    // 商品大类接口
    getGoodsClass (params) {
        return axios.post('/commoditymanagement/itemDept/itemDeptList',qs.stringify(params));
    },

    // 获取资源列表
    getResourceList: (data)=>{
       return axios.post('/special-display/displayRes/page', data)
    },

    // 获取门店信息
    getStoreInfo: (data)=>{
        return axios.post('/institutionmanager/store/getStoreByStoreId', qs.stringify(data), {
            headers: {
                ['Content-Type']: 'application/x-www-form-urlencoded'
            }
        })
    },
    /**
     * 下载文件接口
     * @param  {[type]} url [接口请求地址]
     */
    download: (url)=>{
        return axios({
          method: 'get',
          url: url,
          // data: qs.stringify(params),
          timeout: 1000 * 60 * 2,
          responseType: 'blob'
        });
    },
}

export default resource;



// WEBPACK FOOTER //
// ./src/api/api_resources.js